import { memo, ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import ROUTES from 'shared/constants/routes';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { ErrorBoundaryWrapper } from 'shared/components/ErrorBoundaryWrapper/errorBoundaryWrapper';
import { Navigation } from 'shared/components/Navigation';

declare global {
  interface Window {
    Pusher: unknown;
    Echo: Echo;
  }
}

type TLandingLayoutRoute = {
  isAuth: boolean;
  children?: ReactNode;
};

window.Pusher = Pusher;

const PollsLayoutRoute = ({ isAuth, children }: TLandingLayoutRoute) => {
  if (!isAuth) {
    return <Navigate to={ROUTES.LOGIN.ROUTE} replace />; // TODO Изменить страницу навигации
  }

  const isTMA = () => {
    document.body.classList.add('isPolls');

    return () => {
      document.body.classList.remove('isPolls');
    };
  };
  isTMA();

  console.log('POLLS LAYOUT');

  return (
    <ErrorBoundaryWrapper>
      <div className="wrapper container">
        <main>{children ?? <Outlet />}</main>
        <Navigation />
      </div>
    </ErrorBoundaryWrapper>
  );
};

export default memo(PollsLayoutRoute);
